import styles from './StatusModal.module.scss';

import paymentUserError from '@/assets/img/paymentUserError.jpg';
import paymentUserSuccess from '@/assets/img/paymentUserSuccess.jpg';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Modal } from '@/shared/ui-kit/Modal/Modal';
import { ProgressLoader } from '@/shared/ui-kit/ProgressLoader/ProgressLoader';

type ImageKind = 'success' | 'error';

interface StatusModalProps {
  open: boolean;
  onClose: () => void;
  image: ImageKind;
  headerText: string;
  title: string;
  subtitle: string;
  btnText: string;
  onAction?: () => void;
  imageAlt?: string;
  showLoader?: boolean;
}

const IMG_BY_KIND: Record<ImageKind, string> = {
  success: paymentUserSuccess,
  error: paymentUserError,
};

export const StatusModal: React.FC<StatusModalProps> = ({
  open,
  onClose,
  image,
  headerText,
  title,
  subtitle,
  btnText,
  onAction,
  imageAlt,
  showLoader,
}: StatusModalProps) => {
  const imgSrc = IMG_BY_KIND[image];
  const alt = imageAlt ?? image;

  const handleAction = () => {
    if (onAction) onAction();
    else onClose();
  };

  return (
    <Modal
      hideHeader
      open={open}
      onClose={onClose}
      fullScreen
      fixedBar={
        <Button className={styles.button} onClick={handleAction}>
          {btnText}
        </Button>
      }
      className={styles.modal}
    >
      <h1 className={styles.headerText}>{headerText}</h1>

      <div className={styles.container}>
        <img src={imgSrc} alt={alt} />
        {showLoader && (
          <ProgressLoader active fullScreen={false} color="grey" />
        )}
        <div className={styles.textContainer}>
          <h1 className={styles.title}>{title}</h1>
          <h4 className={styles.subtitle}>{subtitle}</h4>
        </div>
      </div>
    </Modal>
  );
};
